import React, {useContext, Fragment} from "react";


import { useDeleteOcrolusSecret, useUpdateOcrolusSecret, useCreateOcrolusSecret, useGetOcrolusSecrets } from "../api/ocrolussecret.js";
import ListEditComponent from "../components/ui/component-list-edit.js";

import SnackbarContext from "../context/snackbar-context.js";
import UserProfileContext from '../context/userprofilecontext.js';
import PageSkeleton from "../components/ui/pageskeleton.js";
import { handleDisplayResponseResults } from "../api/api_util.js";
import OcrolusSecretForm from "../components/ui/form-ocrolus-secret.js";
import OcrolusSecretEditList from "../components/ui/list-edit-ocrolus-secret.js";

export default function ManageOcrolusSecretPage() {

  console.log('ManageOcrolusSecretPage');

  const userProfileContext=useContext(UserProfileContext);

  const snackbarContext=useContext(SnackbarContext);

  const createOcrolusSecret = useCreateOcrolusSecret();

  const updateOcrolusSecret = useUpdateOcrolusSecret();

  const deleteOcrolusSecret = useDeleteOcrolusSecret();

  if (userProfileContext.error){
    snackbarContext.openSnackbarError(userProfileContext.error)
  }

  if (userProfileContext.isLoading) {
    return (
      <Fragment>
        <PageSkeleton/>
      </Fragment>
    )
  }

  const formatCreateSuccess = (result) => `OcrolusSecret ${result.item.accountName} was created`
  const formatCreateError = (result) => `OcrolusSecret ${result.item.accountName} could not be created`

  const formatUpdateSuccess = (result) => `OcrolusSecret ${result.item.accountName} was updated`
  const formatUpdateError = (result) => `OcrolusSecret ${result.accountName} could not be updated`

  const formatDeleteSuccess = (result) => `OcrolusSecret ${result.item.accountName} was deleted`
  const formatDeleteError = (result) => `OcrolusSecret ${result.item.accountName} could not be deleted`



  const handleCreate = async (data) => {

    try {
      const response = await createOcrolusSecret(data);
      console.log('Create Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatCreateSuccess, formatCreateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };




  const handleUpdate = async (data) => {
    try {

      const response = await updateOcrolusSecret(data);
      console.log('Update Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatUpdateSuccess,formatUpdateError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };


  const handleDelete = async (data) => {
    try {
      const accountName=data.accountName
      console.log(`in handleDelete, accountName=${JSON.stringify(accountName)}`)
      const response = await deleteOcrolusSecret(accountName);
      console.log('Delete Response:', response);
      handleDisplayResponseResults(response, snackbarContext, formatDeleteSuccess, formatDeleteError)
    } catch (error) {
      console.error('Error:', error);
      snackbarContext.openSnackbarError(JSON.stringify(error))
    }
  };


  return (
    <Fragment>
    <ListEditComponent editForm={OcrolusSecretForm} objectLabel="Ocrolus Secret" editList={OcrolusSecretEditList} useGetList={useGetOcrolusSecrets} createHandler={handleCreate} updateHandler={handleUpdate} deleteHandler={handleDelete} />
    </Fragment>
  );
};